import { IconWrapper } from '../runtime';
export default IconWrapper('express-box', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M8.0005 7.7929L2.05564 4.32506M8.0005 7.7929L13.9454 4.32506M8.0005 7.7929V14.9998M2.05564 4.32506C1.84819 4.5928 1.73047 4.92575 1.73047 5.27547V10.724C1.73047 11.2783 2.02617 11.7905 2.50618 12.0676L7.22478 14.7919C7.46479 14.9305 7.73264 14.9998 8.0005 14.9998M2.05564 4.32506C2.17699 4.16846 2.32903 4.03417 2.50618 3.93189L7.22478 1.20761C7.7048 0.930472 8.2962 0.930472 8.77621 1.20761L13.4948 3.93189C13.672 4.03417 13.824 4.16846 13.9454 4.32506M13.9454 4.32506C14.1528 4.5928 14.2705 4.92575 14.2705 5.27547V10.724C14.2705 11.2783 13.9748 11.7905 13.4948 12.0676L8.77621 14.7919C8.53621 14.9305 8.26835 14.9998 8.0005 14.9998M8.00047 3.99976L11.0005 5.99976V9.49976",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});